export default __webpack_public_path__ + "static/media/pressure.334519a0.svg";